import { useRoutes } from 'react-router-dom'
import { ConfigProvider, App as AntApp } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import enUS from 'antd/locale/en_US'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'

// 路由配置
import routes from './routes'

// PWA 安装提示
import InstallPrompt from './components/InstallPrompt'

// 创建 React Query 客户端
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5分钟
      gcTime: 10 * 60 * 1000, // 10分钟
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Ant Design 语言包映射
const antdLocales: Record<string, any> = {
  'zh-CN': zhCN,
  'en': enUS,
}

function App() {
  const routing = useRoutes(routes)
  const { i18n } = useTranslation()
  const antdLocale = antdLocales[i18n.language] || zhCN

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={antdLocale}
        theme={{
          token: {
            colorPrimary: '#1890ff',
            borderRadius: 6,
            colorBgContainer: '#ffffff',
          },
        }}
      >
      <AntApp>
        {routing}
        <InstallPrompt />
        <Toaster position="top-right" />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </AntApp>
      </ConfigProvider>
    </QueryClientProvider>
  )
}

export default App
